import axios from './axios';
import SETTINGS from '../settings'
export default {
    getHireRequest(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/hirerequest`, {params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}